import { createSlice } from '@reduxjs/toolkit';

const initialState = {
   sites: [],
};

const setSites = (state: any, action: any) => {
   state.sites = action.payload;
};

export const siteSlice = createSlice({
   name: 'site',
   initialState,
   reducers: {
      setSites,
   },
});

export default siteSlice;
